import { createSelector } from '@reduxjs/toolkit';

import { GlobalState } from '@/redux/store';

const getSlice = ({ twoStepAuthentication }: GlobalState) => twoStepAuthentication;

export const getTwoStepAuthenticationActivationStatusLoaded = createSelector(getSlice, ({ loaded }) => loaded);
export const getTwoStepAuthenticationActivated = createSelector(getSlice, ({ activated }) => activated);
export const getTwoStepAuthenticationActivationError = createSelector(getSlice, ({ error }) => error);
